export const WEBSITE_PATH = '/website';
export const WEBSITE_EDITOR_PATH = '/website/editor';
